export default "/assets/images/twilight-blue.webp?fbab146aceb9d641234772d07ab16b32";